export const BANNER_VIEWPORTS = [
  {
    viewport: '1440',
    dimension: '1440x0',
    device: 'desktop',
  },
  {
    viewport: '968',
    dimension: '968x0',
    device: 'tablet',
  },
  {
    viewport: '375',
    dimension: '375x0',
    device: 'smartphone',
  },
];
